/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect } from 'react';
import { withActivityContext } from '@bingads-webui-react/hoc-with-signal';

export interface IActivityContext {
  signal: (message: string) => void;
}

export interface IRenderLoggerProps {
  title?: string;
  activity?: IActivityContext | null;
  children?: React.ReactNode;
}

const RenderLoggerInternal: React.FC<IRenderLoggerProps> = ({
  title,
  activity = null,
  children,
}) => {
  useEffect(() => {
    if (activity) {
      activity.signal(`RenderLogger - ${title} has been rendered.`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react/jsx-one-expression-per-line
  return <> { children }</>;
};

export const RenderLogger = withActivityContext<IRenderLoggerProps>(RenderLoggerInternal as any);
